import { MarcoDesenvolvimento, NeuroFaixaEtariaEnum } from 'graphql/types.generated'

const faixaEtariaAtualEnum = (data: ReadonlyArray<MarcoDesenvolvimento>) => data.slice(-1)[0].faixaEtariaEnum

const faixaEtariaAtualDias = (data: ReadonlyArray<MarcoDesenvolvimento>) => data.slice(-1)[0].faixaEtariaFim

const isMaisVelhoQueFaixaEtariaMaxima = (data: ReadonlyArray<MarcoDesenvolvimento>, idadeEmDias: number) =>
  faixaEtariaAtualDias(data) < idadeEmDias

export const isFaixaEtariaAtual = (
  data: ReadonlyArray<MarcoDesenvolvimento>,
  item: MarcoDesenvolvimento,
  idadeEmDias: number
) =>
  !item.alcancadoComMeses &&
  !item.alcancadoComAnos &&
  item.faixaEtariaEnum !== NeuroFaixaEtariaEnum.PRIMEIROS_15_DIAS &&
  item.faixaEtariaEnum === faixaEtariaAtualEnum(data) &&
  !isMaisVelhoQueFaixaEtariaMaxima(data, idadeEmDias)
